import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.TASKS);
const ADMIN_URL = API_CONFIG.getApiUrl('/admin/tasks');

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const taskService = {
  getFeed: async () => {
    const response = await axios.get(`${API_URL}/feed`, getAuthHeader());
    return response.data;
  },

  getSummary: async () => {
    const response = await axios.get(`${API_URL}/summary?tzo=${new Date().getTimezoneOffset()}`, getAuthHeader());
    return response.data;
  },

  claim: async (taskId) => {
    try {
      const response = await axios.post(`${API_URL}/${taskId}/claim`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || 'Nhận đơn thất bại');
      err.errorCode = error.response?.data?.errorCode;
      throw err;
    }
  },

  // 提交完成即转待审核(自动审核放款);proofFile 已废弃,保留参数仅向后端发空 multipart
  submitProof: async (taskId, proofFile) => {
    const form = new FormData();
    if (proofFile) {
      form.append('proof', proofFile);
    }
    const response = await axios.post(`${API_URL}/${taskId}/submit`, form, {
      ...getAuthHeader(),
      headers: {
        ...getAuthHeader().headers,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getMine: async (page = 1, limit = 20) => {
    const response = await axios.get(`${API_URL}/mine?page=${page}&limit=${limit}`, getAuthHeader());
    return response.data;
  },

  getToday: async () => {
    // tzo = 浏览器时区偏移，后端按用户本地日切过滤"今日"
    const response = await axios.get(`${API_URL}/today?tzo=${new Date().getTimezoneOffset()}`, getAuthHeader());
    return response.data;
  },

  getReviews: async () => {
    const response = await axios.get(`${API_URL}/reviews`, getAuthHeader());
    return response.data;
  },

  getLuckyOrders: async () => {
    const response = await axios.get(`${API_URL}/lucky-orders`, getAuthHeader());
    return response.data;
  },

  payLuckyOrder: async (id) => {
    try {
      const response = await axios.post(`${API_URL}/lucky-orders/${id}/pay`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      const data = error.response?.data || {};
      const err = new Error(data.error || translateVi('Thanh toán thất bại'));
      err.errorCode = data.errorCode;
      err.needTopUp = data.needTopUp;
      throw err;
    }
  },

  // 发起 USDT-TRC20 链上支付：返回 { payAmount, address, network, payout }
  startLuckyPayment: async (id) => {
    try {
      const response = await axios.post(`${API_URL}/lucky-orders/${id}/start-payment`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      const data = error.response?.data || {};
      const err = new Error(data.error || translateVi('Không thể bắt đầu thanh toán'));
      err.errorCode = data.errorCode;
      throw err;
    }
  },

  // 支付弹窗轮询用：{ status, payAmount, paidAt }
  getLuckyOrder: async (id) => {
    const response = await axios.get(`${API_URL}/lucky-orders/${id}`, getAuthHeader());
    return response.data;
  }
};

export const adminTaskService = {
  getStats: async () => {
    const response = await axios.get(`${ADMIN_URL}/stats`, getAuthHeader());
    return response.data;
  },

  getPool: async () => {
    const response = await axios.get(`${ADMIN_URL}/pool`, getAuthHeader());
    return response.data;
  },

  createTask: async (payload) => {
    const response = await axios.post(`${ADMIN_URL}/pool`, payload, getAuthHeader());
    return response.data;
  },

  updateTask: async (id, payload) => {
    const response = await axios.put(`${ADMIN_URL}/pool/${id}`, payload, getAuthHeader());
    return response.data;
  },

  enableAllTasks: async () => {
    const response = await axios.post(`${ADMIN_URL}/pool/enable-all`, {}, getAuthHeader());
    return response.data;
  },

  resetQuota: async (id) => {
    const response = await axios.post(`${ADMIN_URL}/pool/${id}/reset-quota`, {}, getAuthHeader());
    return response.data;
  },

  getReviewQueue: async (status = 'pending_review') => {
    const response = await axios.get(`${ADMIN_URL}/review?status=${status}`, getAuthHeader());
    return response.data;
  },

  approve: async (id) => {
    const response = await axios.post(`${ADMIN_URL}/review/${id}/approve`, {}, getAuthHeader());
    return response.data;
  },

  reject: async (id, reason) => {
    const response = await axios.post(`${ADMIN_URL}/review/${id}/reject`, { reason }, getAuthHeader());
    return response.data;
  }
};

export default taskService;
